import type { TranslateService } from '@tolgee/ngx';

export interface IErrorMap {
  pattern: string;
  required: string;
  minlength: string;
  maxlength: string;
  min: string;
  max: string;
  noOnlyWhiteSpaces: string;
  custom: string;
}

export const getErrorsMap = (
  translateService: TranslateService,
  key: string | undefined,
  value: any,
): string => {
  if (!key) {
    return translateService.instant('validation.invalid');
  }
  const errorCodes: any = {
    pattern: translateService.instant('validation.is_not_valid'),
    email: translateService.instant('validation.is_not_valid'),
    hasNumber: translateService.instant('validation.is_not_valid'),
    specificChar: translateService.instant('validation.is_not_valid'),
    hasCapitalCase: translateService.instant('validation.is_not_valid'),
    hasSmallCase: translateService.instant('validation.is_not_valid'),
    noPhoneNumber: translateService.instant('validation.is_not_valid'),
    required: translateService.instant('validation.is_required'),
    minlength: translateService.instant('validation.is_too_short'),
    maxlength: translateService.instant('validation.is_too_long'),
    min: translateService.instant('validation.is_too_small', { min: value ? value[key] : '1' }),
    max: translateService.instant('validation.is_too_big'),
    noOnlyWhiteSpaces: translateService.instant('validation.is_not_empty'),
    noFutureDate: translateService.instant('validation.is_future_date'),
    sameAsPrimary: translateService.instant('validation.is_same_as_primary'),
    custom: '',
  };
  return errorCodes[key];
};
